import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { EffectsModule } from "@ngrx/effects";
import {
  LocalConferenceStreamEffects,
  RemoteConferenceStreamEffects
} from "./+state/effects";
import {
  ConferenceStreamsListService,
  LocalConferenceStreamsListService,
  RemoteConferenceStreamsListService
} from "./+state/service";

@NgModule({
  imports: [
    CommonModule,
    EffectsModule.forFeature([
      LocalConferenceStreamEffects,
      RemoteConferenceStreamEffects
    ])
  ],
  providers: [
    ConferenceStreamsListService,
    LocalConferenceStreamsListService,
    RemoteConferenceStreamsListService
  ]
})
export class ConferenceStreamDataAccessModule {}
